/** @hidden */
export var workbookLocale = 'spreadsheetLocale';
/**
 * Workbook locale text
 *
 * @hidden
 */
export var localeData = {
    SortOutOfRangeError: 'Select a cell or range inside the used range and try again.'
};
